import { render, staticRenderFns } from "./apprNext.vue?vue&type=template&id=194f941a&scoped=true&"
import script from "./apprNext.vue?vue&type=script&lang=js&"
export * from "./apprNext.vue?vue&type=script&lang=js&"
import style0 from "./apprNext.vue?vue&type=style&index=0&id=194f941a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f941a",
  null
  
)

export default component.exports